import { render, staticRenderFns } from "./SourceView.vue?vue&type=template&id=60542eba&scoped=true"
import script from "./SourceView.vue?vue&type=script&lang=js"
export * from "./SourceView.vue?vue&type=script&lang=js"
import style0 from "./SourceView.vue?vue&type=style&index=0&id=60542eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60542eba",
  null
  
)

export default component.exports